/* ==========================================================================
   Rail arrows — the prev/next pair, one engine.

   The news pages carry three scrollers (the "more from" row and any number of
   collection rails lifted out of an article's own body), and
   blocks/sports-sale-grid.liquid had already written this controller once, per
   block, inline. One file instead, for the reason snippets/cart-po-field and
   snippets/cart-fee-reconciler are one file each.

   IT IS NOT THE AUTOPLAY. That is assets/epg-rail-auto.js, which binds the
   same `data-epg-rail` track and owns the dwell rule, the holds and the
   retire-on-interaction behaviour. This file only moves the track when an
   arrow is pressed and decides whether the arrows should be on screen at all.

   THE MARKUP WORKS WITHOUT IT. The track is an ordinary overflow scroller with
   scroll-snap, so it swipes on a phone and scrolls with a trackpad whether or
   not this file arrives; the arrows ship `hidden` and are only revealed once
   there is something to scroll to.

   Contract, per rail:
     [data-rail]            the wrapper both halves are found inside
     [data-rail-track]      the scroller
     [data-rail-prev/next]  the buttons, rendered hidden and disabled
   ========================================================================== */
(function () {
  'use strict';
  if (window.__epgRailArrows) return;
  window.__epgRailArrows = true;

  function step(track) {
    /* One card plus its gap, MEASURED. A round number here is wrong at every
       breakpoint but one — the gap is a clamp — so each press would aim a few
       pixels wide and only the snap points would cover it up.
       blocks/sports-sale-grid.liquid records the same fix. */
    var card = track.firstElementChild;
    if (!card) return track.clientWidth * 0.9;
    var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function bind(rail) {
    if (rail.hasAttribute('data-rail-bound')) return;
    rail.setAttribute('data-rail-bound', '');

    var track = rail.querySelector('[data-rail-track]');
    var prev = rail.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]');
    if (!track || !prev || !next) return;

    function update() {
      /* Whether the row scrolls is a question about THIS screen, not about the
         saved column count — that number is the desktop one and the row shows
         fewer as it narrows. So the arrows ship hidden and appear once the row
         has been measured, at every breakpoint and again on resize. */
      var scrolls = track.scrollWidth > track.clientWidth + 2;
      prev.hidden = next.hidden = !scrolls;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(track), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(track), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    /* A card whose photograph has not decoded yet is narrower than it will be,
       so a row that will overflow can measure as one that does not and the
       arrows never appear. Re-measure as the images land. */
    var shots = track.querySelectorAll('img');
    var pending = 0;
    function settled() {
      pending -= 1;
      update();
      /* assets/epg-rail-auto.js decides whether to OFFER a pause control from
         the same measurement, and it re-measures on resize and on nothing
         else — so a rail whose cards were still undecoded when it first
         looked keeps a pause button for a row that does not move. One
         synthetic resize once the last picture has landed brings both engines
         to the same answer, and costs nothing on a rail with no images. */
      if (pending <= 0) window.dispatchEvent(new Event('resize'));
    }
    for (var i = 0; i < shots.length; i += 1) {
      if (!shots[i].complete) {
        pending += 1;
        shots[i].addEventListener('load', settled, { once: true });
        shots[i].addEventListener('error', settled, { once: true });
      }
    }

    update();
  }

  function run() {
    var rails = document.querySelectorAll('[data-rail]');
    for (var i = 0; i < rails.length; i += 1) bind(rails[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
}());
